export const base = 'rd-station';

export const rdStationAuth = `${base}/auth`;
export const getRDStationToken = `${base}/token`;
